module.exports = __webpack_public_path__ + "media/img/service-img-orther-b8eeb526.png";